import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { LanguageService } from '../services/language.service';


@Injectable()
export class ProfileGuard {
  constructor(
    private router: Router,
    private languageService: LanguageService,
  ) {
  }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<any> {
    await this.languageService.getAll({ language: 'uk' }).toPromise();
    await this.languageService.getAll({ language: 'en' }).toPromise();
    return true;
  }

}
